<template>
	<div class="blacklist-channel">
		<div class="page-tips page-tips--warn">
			<p>
				<span class="tip-label">提示</span>
				黑名单中的渠道不会推送库存，订单自动匹配渠道也不会选择黑名单渠道；订单手动选择渠道时以黑色背景标识
			</p>
		</div>

		<div class="form-section">
			<el-form ref="form" :model="form" :rules="rules" label-width="120px" class="config-form">
				<el-form-item :label="platformShopNameLabel" prop="shopName">
					<el-input v-model="form.shopName" placeholder="请输入店铺名称" disabled />
				</el-form-item>
				<el-form-item label="黑名单渠道" prop="channelId">
					<el-select v-model="form.channelId" placeholder="请选择" filterable :loading="channelLoading">
						<el-option
							v-for="item in channelOptions"
							:key="item.id"
							:label="formatChannelLabel(item)"
							:value="item.id"
						/>
					</el-select>
				</el-form-item>
				<el-form-item label="加入原因" prop="reason">
					<div class="reason-row">
						<el-input v-model="form.reason" placeholder="请填写加入黑名单原因" />
						<el-button type="primary" :loading="saving" @click="onSave">保存</el-button>
					</div>
				</el-form-item>
			</el-form>
		</div>

		<div class="copy-actions">
			<el-button class="tool-btn" @click="onCopyReplace">复制黑名单列表到其他店铺_替换（删除原有数据后，再新增）</el-button>
			<el-button class="tool-btn" @click="onCopyOverwrite">复制黑名单列表到其他店铺_覆盖（不删除原数据，没有的则新增，有的则更新）</el-button>
		</div>

		<div class="table-section">
			<el-table
				ref="table"
				v-loading="listLoading"
				:data="pageList"
				style="width: 100%"
				@selection-change="onSelectionChange"
				@sort-change="onSortChange"
			>
				<el-table-column type="selection" width="48" align="center" />
				<el-table-column prop="shop_name" label="店铺名称" min-width="160" show-overflow-tooltip />
				<el-table-column label="渠道编码" min-width="100" sortable="custom" prop="channel_code">
					<template slot-scope="scope">
						{{ getRowChannelValue(scope.row, ['code', 'channel_code']) }}
					</template>
				</el-table-column>
				<el-table-column label="渠道名称" min-width="120" sortable="custom" prop="channel_name" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ getRowChannelValue(scope.row, ['name', 'channel_name']) }}
					</template>
				</el-table-column>
				<el-table-column label="状态" width="128" align="center">
					<template slot-scope="scope">
						<div class="status-cell" :class="scope.row.state === 1 ? 'is-on' : 'is-off'">
							<el-switch
								v-model="scope.row.state"
								:active-value="1"
								:inactive-value="2"
								active-color="#ff4714"
								inactive-color="#dcdfe6"
								@change="onStateChange(scope.row)"
							/>
							<span class="status-label">{{ scope.row.state === 1 ? '启用' : '禁用' }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="reason" label="加入黑名单原因" min-width="180" sortable="custom" show-overflow-tooltip />
				<el-table-column label="操作" width="72" align="center" fixed="right">
					<template slot-scope="scope">
						<span class="action-link" @click="onDelete(scope.row)">删除</span>
					</template>
				</el-table-column>
			</el-table>

			<div class="page-bar">
				<el-pagination
					v-if="total > 0"
					background
					layout="total, sizes, prev, pager, next, jumper"
					:current-page.sync="page"
					:page-size="pageSize"
					:page-sizes="pageSizes"
					:total="total"
					@current-change="onPageChange"
					@size-change="onPageSizeChange"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import {
	CHANNEL_LIST_TYPES,
	buildChannelSavePayload,
	deleteShopChannel,
	fetchAllChannels,
	fetchShopChannelList,
	formatChannelLabel,
	getRetailShopId,
	getRowChannelValue,
	resetChannelFormAfterSave,
	saveShopChannel,
	saveShopChannelState,
} from './retailShopChannel'
import taobaoPlatformMixin from './taobaoPlatformMixin'

export default {
	name: 'BlacklistChannel',
	mixins: [taobaoPlatformMixin],
	inject: {
		retailShop: { default: null },
	},
	data() {
		return {
			form: {
				shopName: '',
				channelId: '',
				reason: '',
			},
			rules: {
				shopName: [{ required: true, message: '请输入店铺名称', trigger: 'blur' }],
				channelId: [{ required: true, message: '请选择黑名单渠道', trigger: 'blur' }],
				reason: [{ required: true, message: '请填写加入原因', trigger: 'blur' }],
			},
			channelOptions: [],
			channelLoading: false,
			listLoading: false,
			saving: false,
			list: [],
			displayList: [],
			selectedRows: [],
			page: 1,
			pageSize: 10,
			pageSizes: [10, 20, 50],
			total: 0,
			sortProp: '',
			sortOrder: '',
		}
	},
	computed: {
		pageList() {
			const start = (this.page - 1) * this.pageSize
			return this.displayList.slice(start, start + this.pageSize)
		},
	},
	mounted() {
		this.syncShopName()
		this.fetchChannelOptions()
	},
	watch: {
		'retailShop.shopDetail': {
			immediate: true,
			handler() {
				this.syncShopName()
			},
		},
		'retailShop.currentShopId': {
			immediate: true,
			handler(id) {
				if (id) {
					this.fetchList()
				} else {
					this.list = []
					this.applyList()
				}
			},
		},
	},
	methods: {
		syncShopName() {
			if (this.retailShop && this.retailShop.shopName) {
				this.form.shopName = this.retailShop.shopName
			}
		},
		formatChannelLabel(item) {
			return formatChannelLabel(item)
		},
		getRowChannelValue(row, keys) {
			return getRowChannelValue(row, keys)
		},
		fetchChannelOptions() {
			this.channelLoading = true
			fetchAllChannels(this.$axios).then(list => {
				this.channelOptions = list
			}).catch(err => {
				console.log(err)
				this.$message.error(err.message || '获取渠道列表失败')
			}).finally(() => {
				this.channelLoading = false
			})
		},
		fetchList() {
			const shopId = getRetailShopId(this.retailShop)
			if (!shopId) {
				return
			}
			this.listLoading = true
			fetchShopChannelList(this.$axios, shopId, CHANNEL_LIST_TYPES.BLACKLIST).then(list => {
				this.list = list
				this.applyList()
			}).catch(err => {
				console.log(err)
				this.$message.error(err.message || '获取黑名单渠道列表失败')
			}).finally(() => {
				this.listLoading = false
			})
		},
		applyList() {
			let data = [...this.list]
			if (this.sortProp) {
				data.sort((a, b) => {
					const av = a[this.sortProp]
					const bv = b[this.sortProp]
					if (av === bv) return 0
					const result = av > bv ? 1 : -1
					return this.sortOrder === 'descending' ? -result : result
				})
			}
			this.displayList = data
			this.total = data.length
			const totalPages = Math.max(1, Math.ceil(this.total / this.pageSize))
			if (this.page > totalPages) {
				this.page = totalPages
			}
		},
		onSelectionChange(rows) {
			this.selectedRows = rows
		},
		onSortChange({ prop, order }) {
			this.sortProp = order ? prop : ''
			this.sortOrder = order || ''
			this.applyList()
		},
		onSave() {
			this.$refs.form.validate((valid) => {
				if (!valid) return
				const shopId = getRetailShopId(this.retailShop)
				if (!shopId) {
					this.$message.warning('店铺信息不完整')
					return
				}
				this.saving = true
				const payload = buildChannelSavePayload(shopId, CHANNEL_LIST_TYPES.BLACKLIST, {
					channel_id: this.form.channelId,
					reason: this.form.reason,
				})
				saveShopChannel(this.$axios, payload).then(() => {
					resetChannelFormAfterSave(this, this.$refs.form, this.form, ['channelId', 'reason'])
					this.fetchList()
					this.$message.success('保存成功')
				}).catch(err => {
					console.log(err)
					this.$message.error(err.message || '保存失败')
				}).finally(() => {
					this.saving = false
				})
			})
		},
		onDelete(row) {
			if (!row.id) {
				this.$message.warning('配置信息不完整')
				return
			}
			this.$confirm('确定删除该黑名单渠道吗？', '提示', {
				type: 'warning',
			}).then(() => {
				deleteShopChannel(this.$axios, row.id).then(() => {
					this.fetchList()
					this.$message.success('删除成功')
				}).catch(err => {
					console.log(err)
					this.$message.error(err.message || '删除失败')
				})
			}).catch(() => {})
		},
		onStateChange(row) {
			if (!row.id) {
				this.$message.warning('配置信息不完整')
				return
			}
			const newState = row.state
			const oldState = newState === 1 ? 2 : 1
			saveShopChannelState(this.$axios, row, newState).then(() => {
				const item = this.list.find(entry => entry.id === row.id)
				if (item) {
					item.state = newState
				}
				this.$message.success('状态已更新')
			}).catch(err => {
				row.state = oldState
				console.log(err)
				this.$message.error(err.message || '状态更新失败')
			})
		},
		onCopyReplace() {
			this.$message.info('复制黑名单列表到其他店铺（替换）功能待对接')
		},
		onCopyOverwrite() {
			this.$message.info('复制黑名单列表到其他店铺（覆盖）功能待对接')
		},
		onPageChange() {
			this.applyList()
		},
		onPageSizeChange() {
			this.page = 1
			this.applyList()
		},
	},
}
</script>

<style scoped lang="less">
@import '../storeTable.less';
.blacklist-channel {
	padding: 24px 28px 36px;
	background: #fff;
	min-height: 100%;
	box-sizing: border-box;
}

.page-tips {
	margin-bottom: 28px;
	padding: 12px 16px;
	background: #fafbfc;
	border-radius: 6px;
	border: 1px solid #f0f2f5;

	p {
		margin: 0;
		font-size: 13px;
		line-height: 1.8;
		color: #909399;
	}

	&--warn {
		border-color: rgba(230, 162, 60, 0.25);
		background: rgba(230, 162, 60, 0.06);

		p {
			color: #b88230;
		}
	}

	.tip-label {
		display: inline-block;
		margin-right: 6px;
		padding: 1px 8px;
		font-size: 12px;
		color: #e6a23c;
		background: rgba(230, 162, 60, 0.12);
		border-radius: 3px;
	}
}

.form-section {
	margin-bottom: 24px;
	padding-bottom: 24px;
	border-bottom: 1px solid #f2f3f5;
}

.config-form {
	max-width: 720px;

	/deep/ .el-form-item {
		margin-bottom: 18px;
	}

	/deep/ .el-form-item__label {
		font-size: 12px;
		color: #606266;
		line-height: 36px;
		padding-right: 12px;
	}

	/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::before {
		color: #f56c6c;
	}

	.el-input,
	.el-select {
		width: 360px;
		max-width: 100%;
	}

	/deep/ .el-input__inner {
		height: 36px;
		line-height: 36px;
		border-color: #e8eaed;
		border-radius: 4px;
		background: #fafbfc;
		transition: all 0.2s;

		&:hover {
			border-color: #dcdfe6;
			background: #fff;
		}

		&:focus {
			border-color: #ff4714;
			background: #fff;
		}
	}
}

.reason-row {
	display: flex;
	align-items: center;
	gap: 16px;
	flex-wrap: wrap;

	.el-input {
		width: 360px;
		max-width: 100%;
	}

	/deep/ .el-button--primary {
		min-width: 96px;
		height: 36px;
		padding: 0 24px;
		font-size: 12px;
		border-radius: 4px;
		letter-spacing: 1px;
	}
}

.copy-actions {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 12px;
	margin-bottom: 28px;

	.tool-btn {
		flex: 1;
		min-width: 280px;
		min-height: 36px;
		padding: 10px 16px;
		font-size: 12px;
		line-height: 1.5;
		white-space: normal;
		text-align: center;
		border-radius: 4px;
		color: #606266;
		background: #fafbfc;
		border-color: #e8eaed;
	}
}

.table-section {
	.table-section-border();

	/deep/ .el-table {
		font-size: 13px;
		color: #303133;

		&::before {
			height: 0;
		}

		thead {
			font-weight: normal;
		}

		th.el-table__cell {
			background: #fafbfc;
			color: #606266;
			font-weight: normal;
			font-size: 13px;
			padding: 10px 0;
		}

		td.el-table__cell {
			font-size: 13px;
			padding: 10px 0;
		}

		.cell {
			line-height: 1.5;
		}

		tr:hover > td.el-table__cell {
			background: #fafbfc;
		}

		.el-table__empty-text {
			font-size: 13px;
			color: #909399;
		}
	}
}

.status-cell {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 4px 12px 4px 8px;
	border-radius: 20px;
	transition: background 0.2s, box-shadow 0.2s;

	/deep/ .el-switch {
		height: 20px;
		line-height: 20px;

		.el-switch__core {
			width: 36px !important;
			height: 20px;
			border-radius: 10px;

			&::after {
				width: 16px;
				height: 16px;
			}
		}

		&.is-checked .el-switch__core::after {
			margin-left: -17px;
		}
	}

	&.is-on {
		background: rgba(255, 71, 20, 0.1);

		.status-label {
			color: #ff4714;
		}
	}

	&.is-off {
		background: #f5f6f8;

		.status-label {
			color: #909399;
		}
	}
}

.status-label {
	font-size: 13px;
	font-weight: 500;
	line-height: 1;
	letter-spacing: 0.5px;
	user-select: none;
}

.action-link {
	font-size: 13px;
	color: #ff4714;
	cursor: pointer;
	transition: opacity 0.2s;

	&:hover {
		opacity: 0.7;
	}
}

.page-bar {
	display: flex;
	justify-content: flex-end;
	margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/detailed/blacklistChannel.vue